import fork from '@haaretz/l-fork.macro';

import getCommonParameters from '../getCommonParameters';
import getPurchaseServiceLink from '../getPurchaseServiceLink';

import type { UtmHtmProps } from '../getCommonParameters';
import type { SelectedOfferProps } from '@haaretz/s-data-structure-types';

type GetIFrameLinkProps = UtmHtmProps &
  SelectedOfferProps & {
    msPurchase: string;
  };

export default function getPayPalLink({ msPurchase, ...props }: GetIFrameLinkProps) {
  const searchParams = getCommonParameters(props);

  searchParams.set('cgtype', fork({ default: 'heb_paypal', hdc: 'eng_paypal' }));

  return getPurchaseServiceLink({
    msPurchase,
    searchParams,
    endpoint: 'cgPayment',
  });
}
